// libs
import { useEffect, useRef } from "react";

// components
import Alert from "../Alert";

// hooks
import useAlert from "../../hooks/useAlert";

import classes from "./styles.module.css";

export default function AlertsList() {
  const { alerts } = useAlert();
  const listRef = useRef(null);

  useEffect(() => {
    const el = listRef.current;
    if (!el) return;

    el.scrollTop = el.scrollHeight;
  }, [alerts.length]);

  return (
    <div ref={listRef} className={classes.root}>
      {alerts.map((alertData, ind) => (
        <Alert key={ind} data={alertData} />
      ))}
    </div>
  );
}
